export const situacaoPepEnum = [
    {codigo: 0, descricao: "Não"},
    {codigo: 1, descricao: "Sim - Baixo risco"},
    {codigo: 2, descricao: "Sim - Médio risco"},
    {codigo: 3, descricao: "Sim - Alto risco"}
]